import { isEmpty } from '@jjj/components';
import { IChangePropertyPayload } from '@dash/editForm';
import { t } from 'src/i18n';
import { createReducer } from 'src/helpers/reducer';
import actionsTypes from './actionTypes';
import { Attribute, IDenyApplicantState, IFieldTypes } from './types';

function validate(attr: Attribute, value: IFieldTypes) {
  let errorMessage = '';

  const requiredAttributes: Attribute[] = ['denial_reason'];

  if (requiredAttributes.includes(attr)) {
    if (isEmpty(value)) {
      errorMessage = t('dash.validation.required_error', {
        fieldName: t(`dash.applicants.deny_applicant_modal.${attr}_label`),
      });
    }
  }

  return errorMessage;
}

const getInitialField = (fieldName: Attribute, value = '') => ({
  name: fieldName,
  value,
  touched: false,
  error: validate(fieldName, value),
});

const initialEditForm = {
  denial_reason: getInitialField('denial_reason'),
};

const initState: IDenyApplicantState = {
  isLoading: false,
  editForm: initialEditForm,
  isModalVisible: false,
};

function onChangeProperty(
  state: IDenyApplicantState,
  { payload }: { payload: IChangePropertyPayload<Attribute, IFieldTypes> },
): IDenyApplicantState {
  const { attr, value } = payload;
  const { editForm } = state;

  const getValue = (val: IFieldTypes, attribute: Attribute) => ({
    value: val,
    error: validate(attribute, val),
    name: attribute,
    touched: true,
  });

  return {
    ...state,
    editForm: {
      ...editForm,
      [attr]: getValue(value, attr),
    },
  };
}

function onChangeModalVisibility(state: IDenyApplicantState) {
  return {
    ...state,
    isModalVisible: !state.isModalVisible,
  };
}

function onClearState() {
  return {
    ...initState,
  };
}

export default createReducer(initState, {
  [actionsTypes.CHANGE_PROPERTY]: onChangeProperty,
  [actionsTypes.CHANGE_MODAL_VISIBILITY]: onChangeModalVisibility,
  [actionsTypes.CLEAR_STATE]: onClearState,
});
